export default __webpack_public_path__ + "static/media/powered-by-iov.a0397e40.svg";